import { render, staticRenderFns } from "./MultiImageInput.vue?vue&type=template&id=112022cf&scoped=true"
import script from "./MultiImageInput.vue?vue&type=script&lang=ts"
export * from "./MultiImageInput.vue?vue&type=script&lang=ts"
import style0 from "./MultiImageInput.vue?vue&type=style&index=0&id=112022cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112022cf",
  null
  
)

export default component.exports